module.exports = __webpack_public_path__ + "img/20201122_112637.47d1c66e.jpg";